var render, staticRenderFns
import script from "./FormModal.vue?vue&type=script&lang=ts"
export * from "./FormModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bb5958",
  null
  
)

export default component.exports